"use client";

import { useEffect } from "react";
import { Modal } from "@zapier/design-system-beta";
import { Spinner } from "@zapier/design-system";

import type { LibraryTemplate } from "src/server/zsl/templates/types";
import {
  emitUserInteractionEvent,
  UserInteractionEventName,
} from "src/observability/tracking";

import { capitalizedProductStringsSingular } from "src/utils/products";
import styles from "./TemplateCreationModal.module.css";

import type { Product } from "src/utils/products";

type Props = {
  products: Product[];
  slug: LibraryTemplate["meta"]["slug"];
};

export const TemplateCreationModal = ({ products, slug }: Props) => {
  useEffect(() => {
    emitUserInteractionEvent(
      UserInteractionEventName.templateLoadingScreenViewed,
      {
        event_action: "in_view",
        option_selected: slug,
      },
    );
  }, [slug]);

  const productsList = products
    .map((product) => capitalizedProductStringsSingular[product])
    .map((product, index, array) =>
      product === array.at(-1) && array.length > 1 ? `and ${product}` : product,
    )
    .join(", ");

  return (
    <Modal.Root isOpen={true} onOpenChange={() => {}}>
      <Modal.Content className={styles.content} isDismissable={false}>
        <Modal.ContentHeader>Building your workflow...</Modal.ContentHeader>
        <Modal.ContentBody textAlign="center">
          <p>Hold tight! Your shiny new {productsList} will be ready soon.</p>
        </Modal.ContentBody>
        <div
          style={{
            margin: "0 auto",
            width: "fit-content",
          }}
        >
          <Spinner />
        </div>
      </Modal.Content>
    </Modal.Root>
  );
};
